export default __webpack_public_path__ + "static/media/WashBuffalo.804927ba.jpg";